import { apiCall } from '@/lib/api-client';
import type { AgentWithLoad, ReassignInput, ReassignResult } from '@/types/api';

export const reassignmentApi = {
  /** GET /admin/agents — list agents with their open-assignment count. */
  agents: () => apiCall<AgentWithLoad[]>('/admin/agents'),

  /** POST /admin/reassign — move source's queue to target or distribute. */
  reassign: (input: ReassignInput) =>
    apiCall<ReassignResult>('/admin/reassign', {
      method: 'POST',
      body: input,
    }),
};
